<template>
    <BasicTile :rounded="'rounded-16'" class="w-100 background-tile-big">
        <div ref="container" class="referral-code-tile">
            
            
            
            <div class="referral-code-tile__code-container d-flex justify-center">
                <div class="position-absolute w-100 h-100 d-flex flex-column justify-center align-center">
                
                       
                        <div class="referral-code-tile__code text-uppercase">
                            {{ userStore.user.referral_code }}
                        </div>


                        <button class="referral-code-tile__copy-button rounded-pill mt-1 px-4 py-2 d-flex justify-center align-center"
                            @click="copyReferralCode">
                            <v-icon><copy-code></copy-code></v-icon>
                            <span class="referral-code-tile__copy-button__text">Copy Code</span>
                        </button>
                </div>


                <referral-code-background class="referral-code-tile__background w-100"></referral-code-background>

            </div>




            <div :class="{ 'align-center': isStacked, 'align-md-start': !isStacked }"
                class="d-flex flex-column justify-center px-4">




                <div class="referral-code-tile__share-title">
                    Share your code via
                </div>


                <div class="referral-code-tile__share-buttons d-flex flex-row justify-space-around ga-1">
                    <ShareButtons :referralCode="referralCode" :baseUrl="baseUrl" />
                </div>


                <div :class="{ 'text-center': isStacked, 'text-left': !isStacked }" class="referral-code-tile__share-description">
                    Share your Referral Code with friends & family to earn your reward.
                    <br>
                    *Posting codes on app reviews will lead to a ban!*
                </div>





            </div>
        </div>
    </BasicTile>
</template>



<script setup>

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';

import { useUserStore } from "@/store/UserStore";
import { useSnackbar } from '@/composables/useSnackbar';
import { CopyToClipboard } from "@/utils/utils.ts";

import CopyCode from '@/icons/CopyPink.vue';
import BasicTile from '@/components/Tiles/Basic-Tile.vue';
import ShareButtons from '@/components/Referral/Share-Buttons.vue';
import ReferralCodeBackground from '@/icons/ReferralCodeBackground.vue';

const { showSnackbar } = useSnackbar();
const container = ref(null);
const isStacked = ref(false);
const userStore = useUserStore();
const baseUrl = window.location.origin;
const referralCode = computed(() => userStore.user.referral_code);


const copyReferralCode = () => {
    const codeToCopy = referralCode.value;
    try {
        CopyToClipboard(codeToCopy);
        showSnackbar({
            message: 'Copied to clipboard!',
            color: 'info'
        });
    } catch (err) {
        showSnackbar({
            message: 'Error copying to clipboard',
            color: 'error'
        });
    }
};

const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        const containerWidth = entry.contentRect.width;
        // Assuming each column has a min width of 300px, check if there is enough space for 2 columns
        isStacked.value = containerWidth < 600; // 2 * 300px
    }
});

onMounted(() => {
    if (container.value) {
        resizeObserver.observe(container.value);
    }
});

onBeforeUnmount(() => {
    if (container.value) {
        resizeObserver.unobserve(container.value);
    }
});

</script>